import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WalletForm from "../../components/WalletForm";
import { Dispatch, RootState } from "../../store";
import { TransactionProgressContainer, WrappedRow } from "./styled";
import { Headline, Paragraph } from "../../components/styled/Text";
import { FailedTx, ProcessedTx } from "./CountComponents";
import { useWeb3React } from "@web3-react/core";
import Button from "../../components/styled/Button";
import InfoBlock from "./InfoBlock";
import { useNavigate } from "react-router-dom";
import useSnapshotHistory from "../../hooks/useSnapshotHistory";

const Transactions = () => {
  const navigator = useNavigate();
  const { removeSingleSnapshot } = useSnapshotHistory();
  const { chainId, account } = useWeb3React();
  const txCount = useSelector((state: RootState) => state.disperse.txCount);
  const txHashes = useSelector((state: RootState) => state.disperse.txHashes);
  const currentSnapshotId = useSelector(
    (state: RootState) => state.snapshotModel.currentSnapshotId
  );
  const dispatch = useDispatch<Dispatch>();
  const [failedTransactionCount, setFailedTransactionCount] = useState(0);
  const [processedTx, setProcessedTx] = useState(0);

  useEffect(() => {
    const failedTransactionCount = Object.values(txHashes).filter(
      (txHash) => txHash.txHash === null
    ).length;

    const successTransactionCount = Object.keys(txHashes).length;

    setFailedTransactionCount(failedTransactionCount);
    setProcessedTx(successTransactionCount);
  }, [txHashes, txCount]);

  const handleRetry = useCallback(() => {
    if (!account || !chainId) return;
    dispatch.disperse.retryAirdrop({
      account: account,
      chainId: chainId,
    });
  }, [account, chainId, dispatch]);

  const handleReset = useCallback(() => {
    dispatch.disperse.resetState();
    dispatch.snapshotModel.resetState();
    navigator("/token-submit");
  }, [dispatch, navigator]);

  useEffect(() => {
    if (!currentSnapshotId) return navigator("/token-submit");
    dispatch.multistepModel.setCurrentStep(5);
    return () => {
      dispatch.multistepModel.setCurrentStep(4);
    };
  }, [dispatch, currentSnapshotId, navigator]);

  useEffect(() => {
    if (!currentSnapshotId) return;
    if (processedTx === txCount && failedTransactionCount === 0) {
      removeSingleSnapshot(currentSnapshotId);
    }
  }, [
    processedTx,
    failedTransactionCount,
    txCount,
    currentSnapshotId,
    removeSingleSnapshot,
  ]);
  useEffect(() => {
    return () => {
      dispatch.disperse.resetState();
    };
  }, [dispatch]);

  return (
    <TransactionProgressContainer>
      <WalletForm>
        {processedTx === txCount && failedTransactionCount === 0 ? (
          <>
            <InfoBlock />
            <WrappedRow
              direction="column"
              style={{
                marginTop: "20px",
              }}
            >
              <Button onClick={handleReset}>Relaunch another token</Button>
            </WrappedRow>
          </>
        ) : (
          <>
            <WrappedRow>
              <Headline>Transaction Progress</Headline>
              <WrappedRow direction="column">
                <ProcessedTx processedCount={processedTx} txCount={txCount} />
                <FailedTx
                  failedCount={failedTransactionCount}
                  txCount={txCount}
                />
              </WrappedRow>
              <WrappedRow direction="column">
                <Paragraph textAlign="center">
                  Please check your wallet. You will be prompted to confirm the
                  transactions. <br />
                  <strong>Do not close this window</strong> until you confirm
                  the transactions.
                </Paragraph>
              </WrappedRow>
              {processedTx === txCount && failedTransactionCount > 0 && (
                <WrappedRow direction="column">
                  <Button onClick={handleRetry}>
                    Retry Failed Transactions
                  </Button>
                </WrappedRow>
              )}
            </WrappedRow>
          </>
        )}
      </WalletForm>
    </TransactionProgressContainer>
  );
};

export default Transactions;
